import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const Pagination = ({ pages, limit, totalItems, handlePagesnation, currentPage }) => {
    const totalPages = pages?.length || 0;
    let displayPages = [];

    const createRange = (start, end) =>
        Array.from({ length: end - start + 1 }, (_, i) => i + start);

    if (totalPages <= 7) {
        displayPages = createRange(0, totalPages - 1);
    } else if (currentPage <= 3) {
        displayPages = [...createRange(0, 4), 'ellipsis', totalPages - 1];
    } else if (currentPage >= totalPages - 4) {
        displayPages = [0, 'ellipsis', ...createRange(totalPages - 5, totalPages - 1)];
    } else {
        displayPages = [
            0,
            'ellipsis',
            ...createRange(currentPage - 1, currentPage + 1),
            'ellipsis',
            totalPages - 1,
        ];
    }

    const buttonStyle = { margin: "0 2px" };
    return (
        <div className="w-full flex justify-center items-center mt-6 mb-6">
            <div className="flex flex-row items-center gap-4">
                <Button
                    icon={<LeftOutlined />}
                    onClick={() => handlePagesnation("prev")}
                    disabled={currentPage === 0}
                    style={buttonStyle}
                />
                {displayPages.map((page, idx) =>
                    page === 'ellipsis' ? (
                        <Button key={`ellipsis-${idx}`} disabled style={{ ...buttonStyle, pointerEvents: 'none' }}>
                            ...
                        </Button>
                    ) : (
                        <Button
                            key={page}
                            type={currentPage === page ? "primary" : "default"}
                            onClick={() => handlePagesnation(page)}
                            style={buttonStyle}
                        >
                            {page + 1}
                        </Button>
                    )
                )}
                <Button
                    icon={<RightOutlined />}
                    onClick={() => handlePagesnation("next")}
                    disabled={(currentPage + 1) * limit >= totalItems}
                    style={buttonStyle}
                />
            </div>
        </div>
    );
};

export default Pagination;
